import React from 'react';
import PropTypes from 'prop-types';

function CommunicationStyle({
  styles,
  size = 'h5',
}) {
  return (
    <div className={`communication-style ${size}`}>
      <div
        className={styles[0].color}
        title={`Communication style: ${styles[0].value}% ${styles[0].color}`}
        style={{ width: `${styles[0].value}%` }}
      />

      <div
        className={styles[1].color}
        title={`Communication style: ${styles[1].value}% ${styles[1].color}`}
        style={{ width: `${styles[1].value}%` }}
      />

      <div
        className={styles[2].color}
        title={`Communication style: ${styles[2].value}% ${styles[2].color}`}
        style={{ width: `${styles[2].value}%` }}
      />

      <div
        className={styles[3].color}
        title={`Communication style: ${styles[3].value}% ${styles[3].color}`}
        style={{ width: `${styles[3].value}%` }}
      />
    </div>
  );
}

CommunicationStyle.propTypes = {
  styles: PropTypes.arrayOf(PropTypes.shape({
    color: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
  })).isRequired,
  size: PropTypes.string,
};

CommunicationStyle.defaultProps = {
  size: 'h5',
};

export default CommunicationStyle;
